import { RefreshCw } from "lucide-react";
import { useHistory } from "react-router-dom";

import { Filter } from "../../../../components/ui/Filter";
import { PeriodFilter } from "../../../../components/ui/Form/PeriodFilter";
import { CrmPetDiagnosisController } from "../../../../services/controllers/crmPetDiagnosis";
import { CRM_PET_DIAGNOSIS_TABS, useCrmPetDiagnosis } from "../../../../store/crmPetDiagnosis/useCrmPetDiagnosis";
import { PERIOD_OPTIONS } from "../constants";

export function OverviewFilter() {
  const controller = CrmPetDiagnosisController();
  const history = useHistory();
  const filters = useCrmPetDiagnosis((state) => state.data.filters.overview);
  const loading = useCrmPetDiagnosis((state) => state.data.loading);
  const isLoading = loading.diagnosisSummary;

  return (
    <Filter.Root
      onSubmit={(event) =>
        controller.applyFilters(CRM_PET_DIAGNOSIS_TABS.overview, event, history)
      }
    >
      <Filter.Container>
        <PeriodFilter
          withPeriod
          period={filters.period}
          dateFrom={filters.from}
          dateTo={filters.to}
          options={PERIOD_OPTIONS}
          onPeriodChange={(period) => {
            controller.setPeriod(CRM_PET_DIAGNOSIS_TABS.overview, period);
            if (period !== "custom") {
              controller.applyFilters(CRM_PET_DIAGNOSIS_TABS.overview, null, history);
            }
          }}
          onDateChange={(field, value) =>
            controller.setDate(CRM_PET_DIAGNOSIS_TABS.overview, field, value)
          }
        />
      </Filter.Container>
      <Filter.Actions>
        <Filter.Action isLoading={isLoading}>
          <Filter.ActionIcon icon={RefreshCw} isLoading={isLoading} />
          Atualizar visão geral
        </Filter.Action>
      </Filter.Actions>
    </Filter.Root>
  );
}
